const comp_overflow_sliders = document.querySelectorAll(".comp-overflow-slider");


//% Check to see if there are any overflow sliders on the page, don't run if not
if (comp_overflow_sliders.length) {
  //% Loop over each overflow slider
  comp_overflow_sliders.forEach((component) => {
    //% Get slider parts
    const swiperEl = component.querySelector("swiper-container");
    const nav_prev = component.querySelector(".navigation .prev");
    const nav_next = component.querySelector(".navigation .next");
    const pagination = component.querySelector(".pagination");
    // const pagination_index = component.querySelector(".pagination-wrapper .index");
    const pagination_total = component.querySelector(".pagination-wrapper .total");

    const swiper_params = {
      grabCursor: true,
      loop: true,
      pagination: {
        el: pagination,
      },
      navigation: {
        prevEl: nav_prev,
        nextEl: nav_next,
      },
      slidesPerView: 1,
      spaceBetween: 35,
      
      // centeredSlides: true,
      breakpoints: {
        // 0: {},
        768: {
          slidesPerView: 2,
          spaceBetween: 0,
          // spaceBetween: 30,
        },
        1000: {
          slidesPerView: 3,
        },
      },
      on: {
        init: (swiper) => {
          pagination_total.innerText = '0' + swiper.slides.length;
        },
      },
    };


      swiper_init(swiperEl, swiper_params);


  });
}
